<script lang="ts">
  import StatusIcon from '../../../../../../components/StatusIcon.svelte';

  import type { DateCellKey, EntitlementRow } from '../entitlements-table-types';

  export let row: EntitlementRow, cellKey: DateCellKey;
</script>

{#if cellKey === 'isOngoing'}
  <div class="wrap">
    <StatusIcon valid={Boolean(row.isOngoing)} />
    {#if row.onGoingMaxDate}
      <div class="note">
        <em>until {row.onGoingMaxDate}</em>
      </div>
    {/if}
  </div>
{:else if cellKey === 'isDayEntitlement'}
  <StatusIcon valid={row.isDayEntitlement} />
{:else if cellKey === 'expiryDate'}
  {row.expiryDate ?? '—'}
{:else}
  {row[cellKey]}
{/if}

<style>
  .wrap {
    display: flex;
    align-items: center;
  }

  .wrap :global(.status-icon svg) {
    width: 18px;
    height: 18px;
  }

  .wrap .note {
    margin-left: 0.5em;
  }

  .note em {
    font-size: 0.85em;
    color: var(--cds-text-helper);
  }
</style>
